import { emptyFragment } from '@execonline-inc/execonline-ui';
import * as React from 'react';
import { useSizedImage } from './SizedImageStore';
import { SizedImageProps } from './Types';
import { observer } from 'mobx-react';

// The standard React Native `Image` component has the warning:
//
//   "Note that for network and data images, you will need to manually specify the dimensions of
//   your image!"
//
// To get images to render at the proper dimensions, this component was created to query the
// image dimensions and provide those to the wrapped children.
//
const SizedImage: React.FC<SizedImageProps> = ({ uri, children }) => {
  const { state } = useSizedImage(uri);

  switch (state.kind) {
    case 'waiting':
    case 'loading':
    case 'error':
      return emptyFragment();
    case 'ready':
      return children(uri, state.dimensions);
  }
};

export default observer(SizedImage);
